import { animateSimpleDevice } from 'desktop/animations/animateSimpleDevice';
import ScreenSection from '../../components/containers/ScreenSection';
import { useScrollbar } from '../../components/containers/ScrollbarProvider';
import { animateCarouselIn } from '../../animations/animateCarouselIn';
import { animateCarouselOut } from '../../animations/animateCarouselOut';

const SetPriceSection = () => {
  const { useScrollReady } = useScrollbar();

  useScrollReady(setupAnimations);

  return <ScreenSection id={'contribute-set-price'} />;
};

const setupAnimations = () => {
  const trigger = '#contribute-set-price';

  const simpleDevice = animateSimpleDevice(trigger, '#device-price');
  const carouselIn = animateCarouselIn(trigger, '.contribute-set-price-text');
  const carouselOut = animateCarouselOut(trigger, '.contribute-start-with-picture-text');

  return () => {
    simpleDevice.kill();
    carouselIn.kill();
    carouselOut.kill();
  };
};

export default SetPriceSection;
